// Display helpers for "YYYY-MM-DD" calendar dates. Formatting happens in UTC
// on purpose: these are plain dates, not instants.
const fmt = (opts: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat(undefined, { ...opts, timeZone: 'UTC' });
const dayShort = fmt({ weekday: 'short', day: 'numeric', month: 'short' });
const dayLong = fmt({ weekday: 'long', day: 'numeric', month: 'long' });
const weekdayShort = fmt({ weekday: 'short' });
const weekdayLong = fmt({ weekday: 'long' });
const monthDay = fmt({ day: 'numeric', month: 'short' });

const asDate = (date: string) => new Date(`${date}T00:00:00Z`);
export const formatDayShort = (date: string) => dayShort.format(asDate(date));
export const formatDayLong = (date: string) => dayLong.format(asDate(date));
export const formatWeekday = (date: string, long = false) => (long ? weekdayLong : weekdayShort).format(asDate(date));
export const formatMonthDay = (date: string) => monthDay.format(asDate(date));
